import { Avatar as AntAvatar } from 'antd'
import type { ComponentProps } from 'react'

type AntAvatarProps = ComponentProps<typeof AntAvatar>

export interface AppAvatarProps extends AntAvatarProps {}

export const AppAvatar = (props: AppAvatarProps) => <AntAvatar {...props} />

export const AppAvatarGroup = AntAvatar.Group
